import { styled } from '@stitches/configed';
import { Button, Modal } from 'antd';
import { ComponentProps, ReactNode } from 'react';
import WarningIcon from '../Icons/WarningIcon';
import { CloseCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { LoadingOfModal } from '../Loading';

const Icon = styled('div', {
  fontSize: 40,
  marginBottom: 24,
  variants: {
    color: {
      undefined: {
        color: '$brand',
      },
      danger: {
        color: '$danger',
      },
      warning: {
        color: '$warning',
      },
      action: {
        color: '$accent',
      },
    },
  },
});
const Title = styled('div', {
  fontSize: 24,
  fontWeight: 600,
  textAlign: 'center',
});
const DescriptionStyled = styled('div', {
  uTextSize: 'md',
  fontWeight: 400,
  marginTop: 8,
  textAlign: 'center',
});
const FooterStyled = styled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
});

const ModalStyled = styled(Modal, {
  '& .ant-modal-header': {
    paddingTop: 36,
  },
  '& .ant-modal-footer': {
    padding: '24px',
  },
  '& .ant-upload-list-picture-card .ant-upload-list-item-info::before': {
    left: 0,
  },
  variants: {
    hasChildren: {
      false: {
        '& .ant-modal-header': {
          borderBottom: 0,
        },
        '& .ant-modal-body': {
          padding: 0,
        },
        '& .ant-modal-footer': {
          borderTop: 0,
        },
      },
    },
  },
});

export type ModalConfirmProps = ComponentProps<typeof ModalStyled> & {
  visible: boolean;
  confirm?: boolean;
  confirmText?: string;
  icon?: ReactNode;
  type?: 'danger' | 'warning' | 'action';
  title?: string | ReactNode;
  children?: string | ReactNode;
  confirmComponent?: ReactNode;
  confirmDisabled?: boolean;
  confirmLoading?: boolean;
  description?: ReactNode;
  loading?: boolean;
  width?: number;
  onCancel: () => void;
  onConfirm?: (...args: any[]) => any | PromiseLike<any>;
};
const Confirmation = ({
  visible,
  title,
  children,
  icon,
  type,
  confirm,
  confirmText,
  confirmComponent,
  confirmDisabled,
  confirmLoading,
  description,
  loading,
  width,
  onCancel,
  onConfirm,
  ...props
}: ModalConfirmProps) => {
  const iconToRender = (() => {
    if (icon) return icon;
    if (type === 'warning') return <WarningIcon />;
    if (type === 'danger') return <CloseCircleOutlined />;
    if (type === 'action') return <InfoCircleOutlined />;
  })();

  const Footer = confirmComponent ? (
    confirmComponent
  ) : confirm ? (
    <>
      <FooterStyled>
        <Button block className="light" onClick={onCancel}>
          Quay lại
        </Button>
        <Button
          block
          className={type + ' ghost'}
          disabled={confirmDisabled}
          loading={confirmLoading}
          style={{ minWidth: 150 }}
          onClick={onConfirm}
        >
          {confirmText ? confirmText : 'Xác nhận'}
        </Button>
      </FooterStyled>
    </>
  ) : (
    <>
      <FooterStyled>
        <Button type="primary" disabled={confirmDisabled} onClick={onCancel}>
          {confirmText ? confirmText : 'Xác nhận'}
        </Button>
      </FooterStyled>
    </>
  );
  return (
    <ModalStyled
      centered
      width={width || 343}
      visible={visible}
      onCancel={onCancel}
      hasChildren={!!children}
      closable={false}
      title={
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              // marginTop: 24,
            }}
          >
            <Icon color={type}>{iconToRender}</Icon>
          </div>
          {title && <Title>{title}</Title>}
          {!loading && description && (
            <DescriptionStyled>{description}</DescriptionStyled>
          )}
        </>
      }
      footer={Footer}
      {...props}
    >
      {loading ? <LoadingOfModal /> : <>{children}</>}
    </ModalStyled>
  );
};

export default Confirmation;
